import { request } from "../../utils/axios";

export const fetchStat = async () => {
  try {
    const res = await request.get(`courses/my-learning`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

